import PropTypes from 'prop-types'

import { Box, Icon, Heading, Text } from '@redriverpress/system'

// This component is used only to display tags for the Ellii Admins
export default function CollectionAndSublistTagsAlert({ title, tags }) {
  return (
    <Box
      bg='yellow200'
      borderRadius='rounded'
      mt={2}
      p={3}
      display='flex'
      alignItems='baseline'
    >
      <Icon icon='lightbulb' mr={3} />
      <Box>
        <Heading as='h5' mb={0}>
          {title}
        </Heading>
        <Text mt={3}>{tags}</Text>
        <Text mt={3} mb={2} fontSize={0} color='blackAt90'>
          Visible by Ellii admins only
        </Text>
      </Box>
    </Box>
  )
}

CollectionAndSublistTagsAlert.defaultProps = {
  title: 'Collection and Sublist Tags',
}

CollectionAndSublistTagsAlert.propTypes = {
  tags: PropTypes.string.isRequired,
  title: PropTypes.string,
}
